<div class="single-blog-post mb-30">
    <div class="post-image">
        <a routerLink="/knowledge/{{knowledge.id}}" class="d-block">
            <img src="{{knowledge.image.fileUrl}}" alt="image">
        </a>

        <div class="tag">
            <a href="#">{{knowledge.label}}</a>
        </div>
    </div>

    <div class="post-content">
        <ul class="post-meta">
            <li class="post-author">
                    <a routerLink="/knowledge/{{knowledge.id}}" class="d-inline-block">
                       
                <img src="{{knowledge.teacher.avatarUrl}}" class="d-inline-block rounded-circle mr-2" alt="image">
                By: {{knowledge.teacher.name}}</a>
            </li>
            <li *ngIf="knowledge.updatedAt"><a href="#">{{knowledge.updatedAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</a></li>
        </ul>
        <h3><a routerLink="/knowledge/{{knowledge.id}}" href="javascript:;" class="d-inline-block">{{knowledge.title}}</a>
        </h3>
        <a routerLink="/knowledge/{{knowledge.id}}" class="read-more-btn">{{readMore}}<i class='bx bx-right-arrow-alt'></i></a>
    </div>
</div>